import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import { Toaster } from './components/ui/sonner';
import { installPreviewGuard } from './lib/portalMode';

// Off the live host, block every call to the API before anything renders (see lib/portalMode.js).
installPreviewGuard({ axios });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Toaster position="top-right" richColors />
  </React.StrictMode>
);
